{
  "version": 1,
  "asset_id": "47cc20d5-051b-442b-99d5-424c47f521cf",
  "project_id": "fc433a8c-4d23-4f55-8940-e252649f91e6",
  "url": "/__l5e/assets-v1/47cc20d5-051b-442b-99d5-424c47f521cf/pixel-scott-avatar.webp",
  "r2_key": "a/v1/fc433a8c-4d23-4f55-8940-e252649f91e6/47cc20d5-051b-442b-99d5-424c47f521cf/pixel-scott-avatar.webp",
  "original_filename": "pixel-scott-avatar.webp",
  "size": 44508,
  "content_type": "image/webp",
  "created_at": "2026-08-17T05:17:05Z"
}
